import { NioshReport } from '@/types/Niosh';
import { GetNioshReportResponseDTO } from '@/core/dto/niosh';
import { NIOSH_RISKS } from '@/utils/constants';

export class NioshReportMapper {
	constructor(private readonly dto: GetNioshReportResponseDTO) {}

	private getResult(): number {
		const riskIndex = Object.keys(NIOSH_RISKS).findIndex((key) => key === this.dto.risk);
		const result = riskIndex + 1;
		return result;
	}

	toDomain(): NioshReport {
		return {
			id: this.dto.id,
			result: this.getResult(),
			report_name: this.dto.report_name,
			report_type: this.dto.report_type,
			gender: this.dto.gender,
			age: this.dto.age,
			workers: this.dto.workers,
			hands: this.dto.hands,
			coupling: this.dto.coupling || '',
			frequency: Number(this.dto.frequency) || 0,
			duration: this.dto.duration || '',
			mass_m: this.dto.mass_m,
			distance_dc: this.dto.distance_dc,
			dc_factor: this.dto.dc_factor,
			distance_vc: this.dto.distance_vc,
			vc_factor: this.dto.vc_factor,
			distance_h: this.dto.distance_h,
			h_factor: this.dto.h_factor,
			angle_a: this.dto.angle_a,
			a_factor: this.dto.a_factor,
			coupling_factor: this.dto.coupling_factor,
			frequency_factor: this.dto.frequency_factor,
			one_handed_factor: this.dto.one_handed_factor,
			multiple_workers_factor: this.dto.multiple_workers_factor,
			reference_weight: this.dto.reference_weight,
			recommended_weight_limit: this.dto.recommended_weight_limit,
			lifting_index: this.dto.lifting_index,
			risk: this.dto.risk || '',
			collection_date: this.dto.collection_date,
			comment: this.dto.comment,
			consolidated: this.dto.consolidated,
			isActive: this.dto.isActive,
			createdAt: this.dto.createdAt,
			updatedAt: this.dto.updatedAt,
			activity_id: this.dto.activity_id,
			evaluator_id: this.dto.evaluator_id,
			file_id: this.dto.file_id,
			cellule_id: this.dto.cellule_id,
			workstation_id: this.dto.workstation_id,
			report_user_id: this.dto.report_user_id,
			report_user: this.dto.report_user,
			evaluator: this.dto.evaluator,
			activity: this.dto.activity,
			cellule: this.dto.cellule,
			workstation: this.dto.workstation,
			critical_factors: this.dto.critical_factors,
			current_step: this.dto.current_step
		};
	}
}
